// A category linked both directly and via a job function comes as two rows
// with the same id, told apart by `link_type`.
export function getCategoryTableRowKey(item) {
  return item.link_type ? `${item.id}_${item.link_type}` : item.id
}

export function toCategorySelectItem(item) {
  return {
    label: item.name,
    value: item.id,
  }
}

export function toCategorySelectItems(data) {
  return data.map(toCategorySelectItem)
}
